// 366 original daily messages, one per day of the year (index 0 = 1 January)
export const DAILY_QUOTES = [
  "Small actions, consistently taken, create meaningful change.",
  "Begin the year by deciding who you will be, not just what you will do.",
  "Clarity comes from engagement, not thought alone.",
  "The courage to start is the first proof that you are ready.",
  "Every great outcome was once a quiet decision to try.",
  "Progress is built in ordinary moments handled with extraordinary care.",
  "Your standards shape your future more than your circumstances do.",
  "Lead with purpose and the path will reveal itself.",
  "Discipline is choosing what you want most over what you want now.",
  "Steady effort outlasts sudden inspiration.",
  "A clear mind makes brave decisions.",
  "The work you do when no one is watching defines the leader you become.",
  "Growth begins at the edge of your comfort.",
  "Trust is earned in drops and lost in buckets; guard it daily.",
  "Calm is a competitive advantage.",
  "What you nurture grows; choose carefully where you place your attention.",
  "Excellence is not an act but a habit renewed each morning.",
  "Listen deeply; people tell you how to help them.",
  "A kind word at the right moment can change the course of a day.",
  "Resilience is not avoiding the storm but learning to steer through it.",
  "Strong foundations are laid one honest brick at a time.",
  "Measure success by the lives you lift, not the ladders you climb.",
  "Purpose turns effort into fulfilment.",
  "The best teams are built on shared values and clear intentions.",
  "Patience is not passive; it is power under control.",
  "Your energy introduces you before you speak.",
  "Simplicity is the ultimate form of clarity.",
  "Celebrate progress, however small, and momentum will follow.",
  "Do the right thing, especially when it is the hard thing.",
  "Gratitude turns what we have into enough.",
  "A focused hour is worth more than a distracted day.",
  "Integrity is the quiet engine of every lasting success.",
  "Ask better questions and you will find better answers.",
  "Leadership is service with a sense of direction.",
  "Change is inevitable; growth is a choice.",
  "Be the steady presence others can rely on.",
  "Where attention goes, energy flows.",
  "Done with care is better than perfect and delayed.",
  "The strongest people are those who lift others as they rise.",
  "Courage is fear that has said its prayers and stepped forward anyway.",
  "Every setback carries the seed of a comeback.",
  "Consistency turns ordinary people into extraordinary professionals.",
  "Lead your day, or your day will lead you.",
  "A grounded mind sees opportunity where others see obstacles.",
  "Respect is the currency of every healthy workplace.",
  "Your next step does not need to be big, only brave.",
  "Compassion is strength wearing a gentle face.",
  "Plan with ambition, act with humility.",
  "Small improvements, repeated daily, compound into mastery.",
  "Hope is a plan, not a wish, when paired with action.",
  "Make room for rest; it is part of the work.",
  "Great service begins with genuine curiosity about people.",
  "Choose progress over perfection, and keep choosing it.",
  "The way you treat people when they need you most is your true brand.",
  "A vision without action is a dream; action without vision is noise.",
  "Your story is still being written; make today a worthy chapter.",
  "Wisdom is knowing what to overlook.",
  "Strength grows in the moments you think you cannot go on, but do.",
  "Be clear, be kind, and be consistent.",
  "Every conversation is a chance to build trust.",
  "Healthy boundaries create room for healthy relationships.",
  "What you practise in private shows up in public.",
  "Momentum loves those who keep showing up.",
  "Hard days build strong people.",
  "An encouraging word is a gift that costs nothing and gives much.",
  "Focus on what you can influence and release what you cannot.",
  "The quality of your attention is the quality of your life.",
  "Take responsibility, and you take back your power.",
  "Lead by example; words follow footsteps.",
  "Today is an invitation to begin again.",
  "Clarity of purpose silences the noise of distraction.",
  "Character is built in the decisions no one applauds.",
  "Be generous with credit and careful with criticism.",
  "Growth is uncomfortable, but so is staying the same.",
  "Peace begins with a single, intentional breath.",
  "Excellent work is a form of respect for those we serve.",
  "Let your actions be louder than your intentions.",
  "Every expert was once a beginner who refused to quit.",
  "Notice the good, name it, and multiply it.",
  "Commitment is doing what you said long after the mood has passed.",
  "A team that trusts each other can weather any season.",
  "Your mindset is the lens through which every opportunity appears.",
  "Slow down to see clearly, then move with purpose.",
  "Kindness is never wasted.",
  "The future belongs to those who prepare for it today.",
  "Mistakes are lessons in disguise; learn and move forward.",
  "True confidence is quiet; it does not need to be loud.",
  "Invest in people and the results will follow.",
  "Choose words that build bridges, not walls.",
  "Every day you have the chance to be someone's reason to keep going.",
  "Focus breeds results; scattered effort breeds frustration.",
  "Stand firm in your values and flexible in your methods.",
  "A grateful heart is a magnet for good things.",
  "Lead with empathy, decide with clarity.",
  "Small wins are the building blocks of big victories.",
  "Your potential is not fixed; it expands with every effort.",
  "Rest is not a reward for finishing; it is fuel for continuing.",
  "Be the calm in someone else's chaos.",
  "Purpose is found in the service of something greater than yourself.",
  "Reliability is a quiet superpower.",
  "Question assumptions; they are often just old habits.",
  "Every person you meet is carrying something; lead with grace.",
  "Do not wait for opportunity; build it.",
  "Strength is knowing when to ask for help.",
  "The best investment you can make is in your own growth.",
  "Honesty simplifies everything.",
  "A positive culture is created one interaction at a time.",
  "Today, choose courage over comfort.",
  "Persistence turns the impossible into the inevitable.",
  "What you tolerate, you teach.",
  "Show up as the person you want to become.",
  "Encouragement is oxygen for the soul.",
  "Prepare thoroughly, act decisively, reflect honestly.",
  "Success is the sum of small efforts repeated day in and day out.",
  "Your influence is greater than you know; use it well.",
  "Let go of what drains you and nurture what sustains you.",
  "Excellence is in the details others overlook.",
  "Fear fades when action begins.",
  "Build a life and a business you do not need to escape from.",
  "Listen to understand, not to reply.",
  "Progress is a process, not an event.",
  "The right attitude turns challenges into opportunities.",
  "Lead from the heart, guided by the head.",
  "Be proud of how far you have come and excited for where you are going.",
  "A promise kept is a foundation strengthened.",
  "Your daily habits are your future self in the making.",
  "Courageous conversations create healthy organisations.",
  "There is strength in softness and wisdom in stillness.",
  "Commit to learning and you will never stop growing.",
  "Make it easy for people to do the right thing.",
  "Care deeply, act wisely.",
  "Great things are rarely done alone.",
  "One focused step today is worth a hundred tomorrow.",
  "Your worth is not measured by your productivity alone.",
  "Clarity, consistency and compassion build trust.",
  "Turn your setbacks into setups for success.",
  "The quietest people often have the loudest minds; make space for them.",
  "Ownership is the bridge between intention and impact.",
  "Choose to be a source of light today.",
  "Every challenge accepted is a strength developed.",
  "Respond, do not react.",
  "Leadership is measured by the growth of those you lead.",
  "Begin each task with the end in mind.",
  "Value people over processes, and processes will improve.",
  "Hope rises when people feel seen and heard.",
  "Excellence is a journey, not a destination.",
  "Do less, but do it better.",
  "Courage is contagious; let yours inspire others.",
  "The most powerful tool you have is a positive example.",
  "Learn from yesterday, live for today, plan for tomorrow.",
  "Resilient people bend without breaking.",
  "A thoughtful pause can prevent a lasting regret.",
  "Generosity of spirit builds lasting loyalty.",
  "When you know your why, you can endure any how.",
  "Be curious, not judgemental.",
  "Your consistency is someone else's safety.",
  "Trust the process, but keep refining it.",
  "Gratitude is the soil in which joy grows.",
  "Focus on solutions, not on blame.",
  "Success leaves clues; follow them and leave your own.",
  "A strong mind is built with daily, deliberate practice.",
  "Lift your standards and your results will rise to meet them.",
  "People remember how you made them feel long after the details fade.",
  "Every season of struggle prepares you for a season of growth.",
  "Simplify the complex; complicate nothing.",
  "Be brave enough to be a beginner again.",
  "Your actions today write the reputation of tomorrow.",
  "Collaboration multiplies what competition divides.",
  "A good leader takes a little more blame and a little less credit.",
  "Stay humble, stay hungry, stay kind.",
  "The path to mastery is paved with patience.",
  "Speak with intention; your words create worlds.",
  "Comfort is the enemy of growth; curiosity is its friend.",
  "Choose people who choose growth.",
  "Every day offers a fresh page; write something worthwhile.",
  "Be firm on the vision and flexible on the journey.",
  "Nothing changes if nothing changes; take the first step.",
  "The strongest foundations are built on care and accountability.",
  "Your attitude is a choice you make every morning.",
  "Lead calmly, especially when others cannot.",
  "Celebrate the effort, not only the outcome.",
  "Excellence is earned in the quiet hours.",
  "When you serve others well, success follows naturally.",
  "Grace under pressure is a skill worth practising.",
  "What gets measured gets managed; what gets valued gets done.",
  "Give your best to today; tomorrow will thank you.",
  "Fortune favours the prepared mind.",
  "Strong people know their limits and honour them.",
  "Create the culture you wish to work in.",
  "Every no brings you closer to the right yes.",
  "Speak kindly to yourself; you are listening.",
  "Focus is saying no to good things so you can say yes to great ones.",
  "Character is the foundation; competence is the building.",
  "Be a lighthouse, not a storm.",
  "The way forward is often through, not around.",
  "Small acts of care build big circles of trust.",
  "Your future is created by what you do today, not tomorrow.",
  "Be intentional with your time; it is your most precious resource.",
  "A healthy team is a team that feels safe to speak.",
  "Learn something new and you become someone new.",
  "Do what is right, not what is easy.",
  "Peace is found in alignment between values and actions.",
  "Strength grows when we carry each other.",
  "Let today be the day you stop waiting and start building.",
  "Courage begins with a single honest conversation.",
  "Gratitude shifts focus from what is missing to what is present.",
  "Every effort counts, even when the results are not yet visible.",
  "The best leaders create more leaders, not followers.",
  "Keep promises small and keep them always.",
  "Optimism is a discipline, not a personality trait.",
  "Mastery is repetition with reflection.",
  "Make decisions from your values, not your fears.",
  "Well-being is the foundation of high performance.",
  "Kindness and strength are partners, not opposites.",
  "Stay the course; consistency is quietly remarkable.",
  "A clear plan turns overwhelm into action.",
  "Every voice matters in a team that thrives.",
  "Your growth inspires permission for others to grow.",
  "Pause, breathe, then choose your response.",
  "Doing your best is enough; doing it daily is extraordinary.",
  "Build trust by being the same person in every room.",
  "Seek progress in yourself before perfection in others.",
  "The heart of service is attention to the individual.",
  "Clear expectations are an act of kindness.",
  "Let your purpose be bigger than your obstacles.",
  "Encourage often; correct gently.",
  "Your resilience today is building tomorrow's confidence.",
  "Choose quality over quantity in all you do.",
  "Every relationship deserves care and attention.",
  "Lead with questions and you will discover wisdom in your team.",
  "Time spent on preparation is never wasted.",
  "Courage is acting with fear, not without it.",
  "Stay open to feedback; it is a gift that sharpens you.",
  "Bright futures are built in humble beginnings.",
  "Success is not owned; it is rented, and the rent is due every day.",
  "The calmest voice in the room often carries the most weight.",
  "Be accountable to your word and generous with your time.",
  "Your work matters; it changes lives in ways you may never see.",
  "Lead with optimism and others will follow with energy.",
  "Plant seeds of kindness; they grow into forests of trust.",
  "Strength is found in showing up again tomorrow.",
  "Value the journey as much as the destination.",
  "Respect people's time; it is their life in minutes.",
  "Ambition paired with integrity is unstoppable.",
  "Every challenge is a classroom.",
  "Your character is your greatest credential.",
  "Take time to reflect; insight lives in stillness.",
  "Raise the bar, then help others reach it.",
  "Uncertainty is the birthplace of innovation.",
  "Choose to see the best in people and help them see it too.",
  "Good habits are the architecture of a good life.",
  "When the work is meaningful, effort becomes energy.",
  "Recognise effort publicly and offer guidance privately.",
  "One kind act can ripple further than you can imagine.",
  "Clarity is kindness; vagueness is confusion.",
  "Be patient with progress and persistent in effort.",
  "Every day is a chance to lead well.",
  "Self-care is how you take your power back.",
  "Solutions begin with a willingness to listen.",
  "Courage is the foundation upon which every other virtue stands.",
  "Your best is not a fixed point; it rises as you grow.",
  "People thrive where they feel valued.",
  "Small steps forward are still steps forward.",
  "Define success on your own terms and pursue it with heart.",
  "The strongest bonds are built in shared challenges.",
  "Bring your whole self to your work, and invite others to do the same.",
  "A clear conscience is a soft pillow.",
  "Focus on the next right thing.",
  "Leadership is a choice, not a title.",
  "Hard work beats talent when talent does not work hard.",
  "Give people a reason to believe in tomorrow.",
  "Learn to be comfortable with discomfort; that is where growth lives.",
  "A positive mindset is a practice, not a destination.",
  "Honour your commitments and your commitments will honour you.",
  "Your influence starts with how you treat the person in front of you.",
  "Simplicity, clarity and kindness never go out of style.",
  "The strongest trees grow in the strongest winds.",
  "Be the reason someone believes in the goodness of people.",
  "Pursue excellence, not perfection.",
  "Calm minds make wise choices.",
  "The legacy you leave is in the people you develop.",
  "Momentum is built one deliberate action at a time.",
  "Speak up for what matters, even when your voice shakes.",
  "Every day offers a lesson to those willing to learn it.",
  "Care is the most powerful form of professionalism.",
  "Know your values and let them guide every decision.",
  "Your persistence will outrun your doubts.",
  "Create space for others to shine.",
  "Mindful work is meaningful work.",
  "Be thankful for the challenges that made you stronger.",
  "Lead with heart, deliver with excellence.",
  "Opportunities multiply as they are seized.",
  "Balance is not found; it is created.",
  "Courage and kindness together can change any situation.",
  "Make today count; it will never come again.",
  "The best way to predict the future is to create it with care.",
  "True strength is gentle, patient and consistent.",
  "Every honest effort deserves recognition.",
  "Build systems that serve people, not the other way around.",
  "A rested mind is a resourceful mind.",
  "Purpose gives meaning to every task, large or small.",
  "Be the colleague you would want to work beside.",
  "Gratitude is the memory of the heart.",
  "Commit fully to what matters and let go of what does not.",
  "Lead with transparency; trust will follow.",
  "Your daily choices are shaping a remarkable story.",
  "Hold high standards with a warm heart.",
  "There is always something to be grateful for, if you look.",
  "Every season brings its own harvest; trust your timing.",
  "Strong communities are built by people who care.",
  "Your perseverance is quietly inspiring someone today.",
  "Turn your knowledge into action and your action into impact.",
  "A good question can open a closed door.",
  "Be steady in purpose and gentle in approach.",
  "Lasting change starts within.",
  "Champion others and you will never walk alone.",
  "Focus on progress and the destination will take care of itself.",
  "Kind leadership is strong leadership.",
  "Today's discipline is tomorrow's freedom.",
  "Small courtesies create a big difference.",
  "Never underestimate the power of showing up prepared.",
  "Wisdom grows when we stay curious.",
  "You are capable of more than you imagine.",
  "Let your work speak with quality and your character speak with kindness.",
  "Gratitude makes ordinary days feel extraordinary.",
  "Unity of purpose creates strength of action.",
  "Be brave enough to pause and wise enough to reflect.",
  "Every relationship is built on small moments of trust.",
  "The best is yet to come for those who keep going.",
  "Choose growth, choose kindness, choose courage.",
  "Lead today in a way you will be proud of tomorrow.",
  "Quiet determination achieves remarkable things.",
  "Everything worthwhile takes time; honour the process.",
  "Bring light to every room you enter.",
  "When you know better, do better.",
  "Purpose, people and persistence build great organisations.",
  "Your care today becomes someone's hope tomorrow.",
  "A thankful leader creates a thankful team.",
  "Embrace the lessons and release the regrets.",
  "Keep your promises to yourself as faithfully as to others.",
  "A steady hand on the wheel calms every passenger.",
  "Think long term, act today.",
  "Where there is trust, there is speed.",
  "Your voice can be the turning point in someone's day.",
  "Grit is love for the long road.",
  "Make your next decision your best decision.",
  "Clarity of mind begins with an uncluttered day.",
  "The smallest gesture of respect can open the biggest doors.",
  "Each day you choose the legacy you are building.",
  "Lean into the work that scares you; it usually matters most.",
  "Encourage the dreamer in everyone you lead.",
  "Accountability is a gift we give to the people who rely on us.",
  "Hope is the bridge between where you are and where you want to be.",
  "Quality is remembered long after price is forgotten.",
  "Let today's effort be tomorrow's evidence.",
  "Kind honesty is the truest form of care.",
  "When the why is clear, the work becomes lighter.",
  "Stand tall in your purpose, however quietly you walk.",
  "Measure your day by the good you were able to do.",
  "The end of the year is a beginning in disguise.",
  "Rest, reflect and return stronger.",
  "Celebrate every person who made this year possible.",
  "Look back with gratitude and forward with hope.",
  "What you built this year is the foundation for what comes next.",
  "Finish strong; how you end shapes how you begin.",
  "Thank you for every act of courage and care this year.",
];

export function quoteOfTheDay(date = new Date()) {
  const start = new Date(date.getFullYear(), 0, 1);
  const day = Math.floor((date - start) / 86400000);
  return DAILY_QUOTES[day % DAILY_QUOTES.length];
}
